var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"after-purchase"},[_c('h2',{staticClass:"after-purchase__title"},[_vm._v("Dopo l’acquisto…")]),_c('pointer-list',{attrs:{"steps":_vm.steps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }